<template>
  <div>
    <div class="wrapper" v-if="!loading">
      <header-vue :from="prevRoute" />
      <section-vue :birthday-needed="true" />
      <footer-vue />
    </div>
    <transition name="fade">
      <div class="loader-container" v-if="loading">
        <loader-vue />
      </div>
    </transition>
  </div>
</template>

<script>
import LoaderVue from "../../Appointment/common/Loader.vue";
import FooterVue from "../../common/Footer.vue";
import HeaderVue from "./Header.vue";
import SectionVue from "../../common/AddNew/Section.vue";
import { authMixin } from "../../../mixins/authMixin";
import { addNewHomeMixin } from "../../../mixins/addNewHomeMixin";
import { mapMutations } from "vuex";

export default {
  mixins: [authMixin, addNewHomeMixin],
  data() {
    return {
      prevRoute: null
    };
  },
  components: {
    HeaderVue,
    SectionVue,
    FooterVue,
    LoaderVue
  },
  methods: {
    ...mapMutations({
      emptySearchAll: "emptySearchAll"
    }),
    ...mapMutations("clients", {
      clearAddClients: "clearAddClients"
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  destroyed() {
    this.clearAddClients();
    this.emptySearchAll();
  }
};
</script>
